// extracted by mini-css-extract-plugin
export var growableInput = "_38-0";
export var tagContainer = "_38-2";
export var textInput = "_38-1";